import { createUseStyles } from 'react-jss';
import { AlertChildrenProps, AlertProps } from '.';
import { InputTheme } from '@tcl-argon-models/models';
import { inputThemeToAlertBackgroundColor, inputThemeToIconColor } from '@tcl-argon-utils/utils';
import { Classes } from 'jss';

export const useAlertStyles: (
  data?: AlertProps & {
    theme?: InputTheme;
  },
) => Classes<'root' | 'dismissButton'> = createUseStyles({
  root: {
    backgroundColor: ({ theme }: AlertProps) => inputThemeToAlertBackgroundColor(theme),
    // Colorful alerts should have no shadow
    boxShadow: ({ theme }: AlertProps) => {
      if (theme === InputTheme.Error || theme === InputTheme.Warning || theme === InputTheme.Success) {
        return 'none';
      } else {
        return '0 2px 4px 0 #E0E0E0';
      }
    },
    display: 'flex',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '14px',
    maxWidth: '650px',
    padding: '20px',
    position: 'relative',
    width: 'max-content',
    borderRadius: '3px',
  },
  dismissButton: {
    background: 'inherit',
    border: 'none',
    cursor: 'pointer',
    margin: '-5px',
    padding: '5px',
    position: 'absolute',
    right: '20px',
    top: '20px',
  },
});

export const useAlertChildrenStyles = createUseStyles({
  icon: {
    alignSelf: 'first baseline',
    color: ({ theme }: AlertChildrenProps) => inputThemeToIconColor(theme),
    marginRight: '20px',
  },
  title: {
    fontWeight: 'bold',
    marginRight: '20px',
  },
  content: {
    flex: '1 1 auto',
    marginRight: ({ children, isDismissable }: AlertChildrenProps) =>
      isDismissable || children.action != null ? '40px' : '',
  },
  action: {
    fontSize: '12px',
    marginRight: ({ isDismissable }: AlertChildrenProps) => (isDismissable ? '15px' : undefined),
  },
  dismissButtonSpacer: {
    width: '20px',
  },
});
